import { motion } from 'framer-motion';

const ServicesGrid = () => {
  const services = [
    {
      title: 'Emergency Plumbing',
      category: '24/7 Available',
      image: 'https://public.readdy.ai/ai/img_res/2bf78b6cf163b0ca85cd22c27c280ac2.jpg',
      items: [
        'Burst pipe repairs',
        'Emergency leak detection',
        'Blocked drains and toilets',
        'Water heater failures',
        'Gas leak detection',
      ],
    },
    {
      title: 'Boiler Services',
      category: 'Gas Safe Registered',
      image: 'https://readdy.ai/api/search-image?query=Modern%20condensing%20boiler%20installation%20on%20clean%20white%20wall%20with%20visible%20pipes%20and%20controls%2C%20professional%20installation%20showing%20technical%20precision%2C%20contemporary%20UK%20home%20interior%20setting%2C%20natural%20lighting%2C%20simple%20neutral%20background%20emphasizing%20quality%20equipment%20and%20expert%20installation&width=800&height=600&seq=service-boiler-001&orientation=landscape',
      items: [
        'New boiler installation',
        'Annual boiler servicing',
        'Boiler repairs and diagnostics',
        'System upgrades',
        'Energy efficiency advice',
      ],
    },
    {
      title: 'Central Heating',
      category: 'Expert Solutions',
      image: 'https://readdy.ai/api/search-image?query=White%20modern%20radiator%20mounted%20on%20neutral%20wall%20in%20comfortable%20living%20room%2C%20close-up%20showing%20clean%20design%20and%20efficient%20heating%2C%20warm%20home%20interior%20with%20soft%20natural%20light%2C%20simple%20background%20emphasizing%20comfort%20and%20warmth%20for%20family%20home&width=800&height=600&seq=service-heating-001&orientation=landscape',
      items: [
        'Radiator installation and replacement',
        'Heating system repairs',
        'Power flushing',
        'Thermostatic controls',
        'System balancing',
      ],
    },
    {
      title: 'Bathroom Installation',
      category: 'Complete Service',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20modern%20bathroom%20with%20white%20suite%20including%20bathtub%20and%20contemporary%20fixtures%2C%20clean%20minimalist%20design%20with%20chrome%20taps%20and%20fittings%2C%20soft%20natural%20lighting%2C%20neutral%20color%20palette%20emphasizing%20luxury%20and%20cleanliness%20for%20professional%20installation%20showcase&width=800&height=600&seq=service-bathroom-001&orientation=landscape',
      items: [
        'Full bathroom design and installation',
        'Shower and bath fitting',
        'Bathroom refurbishment',
        'Wetroom installation',
        'Sanitary ware replacement',
      ],
    },
    {
      title: 'Drainage Services',
      category: 'Professional',
      image: 'https://readdy.ai/api/search-image?query=Professional%20drain%20inspection%20with%20camera%20equipment%20showing%20underground%20pipe%20system%2C%20technical%20diagnostic%20tools%20being%20used%20by%20expert%20hands%2C%20modern%20drainage%20technology%2C%20clean%20technical%20background%20emphasizing%20expertise%20and%20thorough%20problem-solving%20approach&width=800&height=600&seq=service-drainage-001&orientation=landscape',
      items: [
        'Drain unblocking',
        'CCTV drain surveys',
        'Drain repairs',
        'Gutter cleaning and repairs',
        'Waste pipe installation',
      ],
    },
    {
      title: 'Landlord Services',
      category: 'Certified',
      image: 'https://readdy.ai/api/search-image?query=Professional%20engineer%20conducting%20safety%20inspection%20with%20clipboard%20and%20tools%20in%20rental%20property%2C%20checking%20boiler%20and%20plumbing%20systems%2C%20formal%20documentation%20process%2C%20clean%20modern%20home%20interior%2C%20neutral%20background%20emphasizing%20professional%20certification%20and%20compliance%20standards&width=800&height=600&seq=service-landlord-001&orientation=landscape',
      items: [
        'Landlord gas safety certificates',
        'Property maintenance',
        'Emergency callouts for tenants',
        'Annual safety inspections',
        'Multi-property contracts',
      ],
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all"
            >
              {/* Image */}
              <div className="relative h-56 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 left-4 bg-[#1A2F4A]/90 text-white text-xs px-4 py-2 rounded-full whitespace-nowrap">
                  {service.category}
                </div>
              </div>

              {/* Content */}
              <div className="p-8">
                <h3 className="text-2xl font-bold text-[#1A2F4A] mb-4">{service.title}</h3>
                <ul className="space-y-2.5">
                  {service.items.map((item, i) => (
                    <li key={i} className="flex items-start space-x-3 text-gray-600 text-sm">
                      <i className="ri-check-line text-[#1A2F4A] text-lg mt-0.5 flex-shrink-0"></i>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;